import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'

Vue.use(VueRouter)

const router = new VueRouter({
    mode: "history",
    routes
  })

router.beforeEach((to, from, next) => {
  // Start at the top for the new page
  window.scrollTo(0, 0);
  
  if (!to.matched.length)
    next({ path: '/PageNotFound' });
  else
    next();
})

export default router